import type React from 'react';

import { FormField, Input, Label } from '@zillow/constellation';

type Props = {
  value: string;
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  dataTest?: string;
};

export default function SecurityDepositBankNameInput({ dataTest, ...rest }: Props) {
  return <FormField label={<Label>Name of deposit bank</Label>} control={<Input {...rest} data-test={dataTest} />} />;
}
